export default "__VITE_ASSET__cf1852ec__"